// TODO: BSD-34948 - This entire file is deprecated
//   * In general, replace usage of react-select and react-select/Async with components/ui/select
//   * For getOption/getOptions, use the `primitiveOptions` prop of components/ui/select instead
//   * Inline mapId/mapName functions instead of importing
//   * Styles are all obsolete, as components/ui/select styles itself - some inline zIndex styles may still be needed
//   * Inline and horizontal form styles are no longer necessary
//   * Use isClearable={false} instead of unclearableMultiValueComponents
//   * getPortaledMenuProps is no longer necessary

import React from 'react';

export const getOption = value => ({ value: value || '', label: value });
export const getOptions = values => values.map(getOption);
export const mapId = item => item.id;
export const mapName = item => item.name;

export const formInputStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: `${state.isFocused ? 'oklch(81.36% 0.09 249.96 / 1)' : 'oklch(88.69% 0.01 259.82 / 1)'}`,
    borderWidth: 1,
    borderRadius: 6,
    boxShadow: 'none',
    marginBottom: 4,
    minHeight: 37,
    height: 37,
  }),
};

export const inlineStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: `${state.isFocused ? 'oklch(81.36% 0.09 249.96 / 1)' : 'oklch(88.69% 0.01 259.82 / 1)'}`,
    borderWidth: 1,
    borderRadius: 6,
    minHeight: 30,
  }),

  indicatorsContainer: base => ({
    ...base,
    marginTop: -8,
    marginBottom: -8,
  }),

  placeholder: base => ({
    ...base,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),
};

export const horizontalFormStyles = applyStyleOverrides(inlineStyles, {
  control: {
    height: 37,
    minHeight: 37,
    borderWidth: 1,
    borderTopRightRadius: 6,
    borderBottomRightRadius: 6,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },

  valueContainer: {
    height: 37,
    paddingTop: 0,
  },
});

export function applyStyleOverrides(styles, overrides = {}) {
  styles = { ...styles };

  for (const key in overrides) {
    if (styles[key]) {
      const baseFn = styles[key];
      styles[key] = (base, state) => ({
        ...baseFn(base, state),
        ...overrides[key]
      });
    } else {
      styles[key] = base => ({
        ...base,
        ...overrides[key]
      });
    }
  }

  return styles;
}

export function getInlineStyles(overrides = {}) {
  return applyStyleOverrides(inlineStyles, overrides);
}

export function getHorizontalFormStyles(options = {}) {
  const overrides = options.overrides || {};
  if (options.error) {
    // TODO: How to share colors between JS CSS and our SCSS variables?
    overrides.control = { ...overrides.control, 'border-color': '#f97979' };
  }

  return applyStyleOverrides(horizontalFormStyles, overrides);
}

export const unclearableMultiValueComponents = {
  MultiValueRemove() {
    return <span>&nbsp;</span>;
  }
};

// DEPRECATED: Use menuPosition="fixed" instead
export function getPortaledMenuProps(styles = {}) {
  return {
    menuPortalTarget: document.body,
    styles: {
      ...styles,
      menuPortal: base => ({ ...base, 'z-index': '9999' })
    }
  };
}
